import { Box, Typography, Breadcrumbs, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumbs = [],
  /** Titre un peu plus compact (pages outil fréquentes). */
  dense = false,
}) {
  return (
    <Box
      sx={{
        mb: dense ? 1.75 : 2,
        p: dense ? { xs: 1.25, md: 1.5 } : { xs: 1.5, md: 1.75 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        boxShadow: '0 1px 3px rgba(47, 29, 15, 0.04)',
      }}
    >
      {breadcrumbs.length > 0 && (
        <Breadcrumbs sx={{ mb: 0.75 }}>
          {breadcrumbs.map((bc, i) => (
            bc.to ? (
              <Link key={i} component={RouterLink} to={bc.to} underline="hover" color="inherit">
                {bc.label}
              </Link>
            ) : (
              <Typography key={i} color="text.primary">{bc.label}</Typography>
            )
          ))}
        </Breadcrumbs>
      )}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        spacing={1.5}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant={dense ? 'h5' : 'h4'} component="h1" fontWeight={700}>
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.35, maxWidth: 640, lineHeight: 1.45 }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && <Box sx={{ width: { xs: '100%', md: 'auto' }, flexShrink: 0 }}>{actions}</Box>}
      </Stack>
    </Box>
  );
}
